import type { PartnerConfig } from './types';

export const partners: PartnerConfig[] = [
  {
    id: 'sin-city',
    name: 'Sin City',
    description:
      'Cartel empire builder with territory warfare, weapon upgrades, and resource extraction.',
    logo: '',
    color: '#ff6b35',
    status: 'coming-soon',
    createAdapter: () => {
      throw new Error('Sin City adapter not yet implemented');
    },
    pages: [],
    caseStudy: null,
    externalUrl: '/sin-city',
  },
  {
    id: 'trench-royale',
    name: 'Trench Royale',
    description: 'Competitive multiplayer arena with ranked matches and in-game economy.',
    logo: '',
    color: '#a855f7',
    status: 'coming-soon',
    createAdapter: () => {
      throw new Error('Trench Royale adapter not yet implemented');
    },
    pages: [],
    caseStudy: null,
  },
];

export function getPartner(id: string): PartnerConfig | undefined {
  return partners.find((p) => p.id === id);
}
